import React, { Component } from 'react';

// components
import ClusterMap from '../../components/cluster-map/cluster-map';

class PropertyDetailMap extends Component {
  render() {
    const { record, ...props } = this.props;

    return (
      <ClusterMap
        defaultCenter={{
          lat: parseFloat(record.get('latitude'), 10),
          lng: parseFloat(record.get('longitude'), 10)
        }}
        defaultZoom={15}
        bootstrapURLKeys={{
          key: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
          v: 3
        }}
        {...props}
        markers={this.getMarkers()}
      />
    );
  }

  getMarkers() {
    const { record } = this.props;
    const markers = [
      {
        id: record.get('id'),
        lat: parseFloat(record.get('latitude'), 10),
        lng: parseFloat(record.get('longitude'), 10)
      }
    ].filter(({ lat, lng }) => !isNaN(lat) && !isNaN(lng));

    return markers;
  }
}

export default PropertyDetailMap;



// WEBPACK FOOTER //
// ./src/containers/PropertyDetail/PropertyDetailMap.js